module.exports = __webpack_public_path__ + "img/vertical_layout_1.3a08c6bc.jpg";